import script from "./OverseasPromotion.vue?vue&type=script&setup=true&lang=js"
export * from "./OverseasPromotion.vue?vue&type=script&setup=true&lang=js"

import "./OverseasPromotion.vue?vue&type=style&index=0&id=cf8bacde&lang=scss"

const __exports__ = script;

export default __exports__